import Dal from '../scripts/dataaccess'
import { LogEntry, AppDatabase, LogItem } from './AppDatabase'
import * as Fingerprint from 'fingerprintjs2';

class PortalStat {
    category: string;
    eventName: string;
    eventIdentifier: string;

    count: number = 0;
    maxTime: number = 0;
    minTime: number = 99999999999;
    avgTime: number = 0;

    constructor(category: string, name: string, identifier: string) {
        this.category = category;
        this.eventName = name;
        this.eventIdentifier = identifier;
    }

    AddStat(time?: number) {
        if (time) {
            this.avgTime = ((this.avgTime * this.count) + time) / (this.count + 1)
            this.maxTime = Math.max(this.maxTime, time);
            this.minTime = Math.min(this.minTime, time);
        }
        this.count++;
    }
}




class UiStatCollector {

    stats: { [key: string]: PortalStat } = {}
    recorder: UiCachedRecorder
    constructor(recorder: UiCachedRecorder) {
        this.recorder = recorder;
        setInterval(() => {
            this.LogStats();
        }, 5 * 60 * 1000)
    }

    public LogStats() {
        console.log("-----------------------------Logging Stats-------------------------------------")
        var stats = [];
        for (var key of Object.keys(this.stats)) {
            stats.push(this.stats[key])
        }

        this.stats = {};
        var items: LogItem[] = []
        for (var stat of stats) {
            var item = new LogItem();
            item.category = stat.category;
            item.eventIdentifier = stat.eventIdentifier;
            item.eventName = stat.eventName;
            var eventData : { [key: string]: string } = {};
            eventData["AvgTime"] = stat.avgTime.toString();
            eventData["MinTime"] = stat.minTime.toString();
            eventData["MaxTime"] = stat.maxTime.toString();
            eventData["Count"] = stat.count.toString();
            item.eventData = eventData;
            items.push(item);
        }
        this.recorder.EnqueEntries(items);
    }

    public AddStat(category: string, eventName: string, eventIdentifier: string, time?: number) {

        var key = category+"." + eventName + "." + eventIdentifier;
        if (this.containsKey(key)) {
            this.stats[key].AddStat(time);
        }
        else {
            this.stats[key] = new PortalStat(category, eventName, eventIdentifier);
        }
        console.log("------------------------- Adding Stat")
        console.log(this.stats)
    }

    private containsKey(key: string) {
        if (typeof this.stats[key] === "undefined") {
            return false;
        }
        return true;
    }
}



class UiCachedRecorder {

    unitId: string;
    session: number;
    fingerPrint: string;

    db: AppDatabase;
    dal: Dal
    initializer: Promise<void>

    constructor(unitId: string, session:number, fingerPrint:string) {
        this.unitId = unitId;
        this.session = session;
        this.fingerPrint = fingerPrint;

        this.db = new AppDatabase();
        this.initializer = this.db.bootstrap();
        this.dal = new Dal();
    }

    public EnqueEntries(items: LogItem[]) {
        var addItems = () => {
            for (var item of items) {
                this.db.logQueue.add(new LogEntry(this.unitId, this.session, this.fingerPrint, item));
            }
            setTimeout(() => this.DequeEntry(), 1000);
        }

        if (this.initializer)
            this.initializer.then(() => addItems())
        else 
            addItems();
    }

    public EnqueEntry(item: LogItem) {
        var addItem = () => {
            this.db.logQueue.add(new LogEntry(this.unitId, this.session, this.fingerPrint, item));
            setTimeout(() => this.DequeEntry(), 1000);
        }


        if (this.initializer) 
            this.initializer.then(() => addItem())
        else 
            addItem();
    }

    public DequeEntry() {
        var processed: Array<LogEntry> = [];
        var that = this;

        this.db.logQueue
            .each(item => processed.push(item))
            .then(() => that.SendLogEntry(processed));
    }

    private SendLogEntry(items: LogEntry[]) {
        //var data = { ...item.data };

        this.dal.RemoteLog(items).then(() => {
            for (var item of items) {
                var id = item.id;
                console.log("Deleting Id : " + id);
                if (id) {
                    this.db.logQueue.delete(id);
                }
            }
        })
    }

}



export default class UiSession {

    logEndPoint: string;
    unitId: string;
    session: number;
    fingerPrint: string;

    recorder: UiCachedRecorder;
    sessionData: Array<any>;
    statCollector: UiStatCollector;

    constructor(unitId: string) {
        this.unitId = unitId;
        this.session = new Date().getTime();
        
        this.GetTrackerDataAsync().then(data => {
            this.recorder = new UiCachedRecorder(unitId, this.session, data[0]);
            this.statCollector = new UiStatCollector(this.recorder);
            this.LogEvent("SessionStart", data[1]);
        })

        window.addEventListener("beforeunload", e => {
            this.statCollector.LogStats();
            this.LogEvent("SessionStop")
        });
    }

    public LogEvent(eventName: string, data?: { [key: string]: string }) {
        try {
            this.log("Event", eventName, data);
        }
        catch (e) {
            //Stop bubbling any logging issues
            console.log("Error in logging", e)
        }
    }

    public LogStat(category: string, eventName: string, eventIdentifier: string, time?: number) {
        try {
            this.statCollector.AddStat(category, eventName, eventIdentifier, time);
        }
        catch (e) {
            //Stop bubbling any logging issues
            console.log("Error in logging", e)
        }
    }

    private log(category: string, eventName: string, data?: { [key: string]: string }){
        var logItem = new LogItem();
        logItem.category = category;
        logItem.eventName = eventName;
        logItem.eventData = data;

        this.recorder.EnqueEntry(logItem);
    }


    private async GetTrackerDataAsync(): Promise<[string, { [key: string]: string }]>{
        var trackers = [
            "userAgent",
            "language",
            "deviceMemory",
            "hardwareConcurrency",
            "timezone",
            "platform"
        ]
        var sessionTrackerData: { [key: string]: string } = {};
        var result: [string, { [key: string]: string }];
        return Fingerprint.getPromise({}).then((components: any[]) => {

            var allValues = components.map(c => c.value);
            var fp = Fingerprint.x64hash128(allValues.join(""), 31);

            var values = components.filter(c => trackers.indexOf(c.key) >= 0);
            var resolution = components.filter(c => c.key == "screenResolution")[0].value;
            values.push({ key: "screenResolution", value: resolution[0] + "x" + resolution[1] });

            for (var value of values) {
                var key = value.key as string;
                sessionTrackerData[key] = value.value;
            }


            result = [ fp, sessionTrackerData ];
            return result;
        })
    }
}


//export default class UiSession {

//    logEndPoint : string;
//    unitId: string;
//    session: number;
//    fingerPrint: string;
//    db: AppDatabase;
//    sessionData: Array<any>;
//    dal: Dal

//    constructor(unitId: string) {
//        this.unitId = unitId;
//        this.session = new Date().getTime();
//        this.db = new AppDatabase();
//        this.dal = new Dal();
//        //this.Log("Start");
//        this.GetTrackerData()
//        window.addEventListener("beforeunload", e => this.Log("Stop"));
//    }


//    public Log(type: string, msg?: string | null, data?: { [key: string]: string } ) {
//        var url = "log/session?type=" + type;
//        console.log({
//            url: url,
//            type: type,
//            fingerprint: this.fingerPrint,
//            session: this.session,
//            localTime: new Date(),
//            message: msg,
//            data: data
//        });

//        this.EnqueEntry("log/session", {
//            session: this.session,
//            unitId: this.unitId,
//            fingerprint: this.fingerPrint,
//            type: type,
//            localTime: new Date(),
//            message: msg,
//            data: data
//        });

//    }



//    EnqueEntry(url: string, data: any) {
//        this.db.logQueue.add({ session: this.session, endpoint: url, data: data });
//        setTimeout(() => this.DequeEntry(), 1000);
//    }

//    DequeEntry() {
//        var processed: Array<LogEntry> = [];
//        var that = this;

//        this.db.logQueue
//            .each(item => processed.push(item))
//            .then(() => {
//                for (var item of processed) {
//                    that.SendLogEntry(item);
//                }
//            })
//    }

//    SendLogEntry(item: LogEntry) {
//        var id = item.id;
//        var data = { ...item.data };
        
//        this.dal.LogUiSession(data).then(() => {
//            console.log("Deleting Id : " + id);
//            if (id) {
//                this.db.logQueue.delete(id);
//            }
//        })
//    }



//    GetTrackerData() : void{
//        var trackers = [
//            "userAgent",
//            "language",
//            "deviceMemory",
//            "hardwareConcurrency",
//            "timezone",
//            "platform"
//        ]
//        var sessionTrackerData: { [key: string]: string } = {};

//        Fingerprint.get({}, (components: any[]) => {
//            var allValues = components.map(c => c.value);
//            this.fingerPrint = Fingerprint.x64hash128(allValues.join(""), 31);

//            var values = components.filter(c => trackers.indexOf(c.key) >= 0);
//            var resolution = components.filter(c => c.key == "screenResolution")[0].value;

//            values.push({ key: "screenResolution", value: resolution[0] + "x" + resolution[1] });

//            for (var value of values) {
//                var key = value.key as string;
//                sessionTrackerData[key] = value.value;
//            }

//            console.log("---------------FingerPrint-----------------");
//            console.log(values);

//            this.Log("Start", null, sessionTrackerData);
//        })
//    }
//}



// WEBPACK FOOTER //
// ./ClientApp/Tracking/LogManager.ts